import { render, staticRenderFns } from "./CtrlProcessoPage.vue?vue&type=template&id=1281cbc4"
import script from "./CtrlProcessoPage.vue?vue&type=script&lang=js"
export * from "./CtrlProcessoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports